export const tabTitle = (tabVal) => {
    document.title = 'Gameup | ' + tabVal;
}